<template>
  <page-component :loading="loading" class="agent-data-page">
    <template #content>
      <v-sheet style="border-radius: 4px" :class="{ sticky: active }" id="nav">
        <div style="display: flex; justify-content: center; align-items: center">
          <v-tabs
            id="nav-container"
            :class="toggleNavClass()"
            color="transparent"
            center-active
            icons
            class="d-flex align-center justify-center py-2"
            v-model="tab"
            style="height: 52px !important"
          >
            <v-tab
              :disabled="requestTabsDisabled"
              replace
              :style="
                activeRouteName == 'agent_data'
                  ? 'background-color: #40BE72; color: white; border-radius: 3px'
                  : ''
              "
              :to="detailsTabTo('agent_data')"
              :aria-label="tabLabels.agent_data"
            >
              <v-tooltip bottom open-delay="200" :disabled="activeRouteName == 'agent_data'">
                <template #activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="d-inline-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22.212"
                height="22.212"
                viewBox="0 0 24.212 24.212"
                class="ml-2"
              >
                <g
                  id="_Group_user"
                  data-name="&lt;Group&gt;user"
                  transform="translate(0.5 0.5)"
                >
                  <ellipse
                    id="_Path_"
                    data-name="&lt;Path&gt;"
                    cx="6.462"
                    cy="5.816"
                    rx="6.462"
                    ry="5.816"
                    transform="translate(5.117)"
                    fill="none"
                    :stroke="activeRouteName == 'agent_data' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                  />
                  <path
                    id="_Path_2"
                    data-name="&lt;Path&gt;"
                    d="M13.106,14.5a20.714,20.714,0,0,0-9.185,2.432A4.421,4.421,0,0,0,1.5,20.878v.807a1.658,1.658,0,0,0,1.658,1.658h19.9a1.658,1.658,0,0,0,1.658-1.658v-.807a4.421,4.421,0,0,0-2.421-3.946A20.714,20.714,0,0,0,13.106,14.5Z"
                    transform="translate(-1.5 -0.131)"
                    fill="none"
                    :stroke="activeRouteName == 'agent_data' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                  />
                </g>
              </svg>
                  </span>
                </template>
                <span>{{ tabLabels.agent_data }}</span>
              </v-tooltip>
              <span v-if="activeRouteName == 'agent_data'">{{ tabLabels.agent_data }}</span>
            </v-tab>
            <v-tab
              :disabled="requestTabsDisabled"
              replace
              :style="
                activeRouteName == 'real_estate_data'
                  ? 'background-color: #40BE72; color: white; border-radius: 3px'
                  : ''
              "
              :to="detailsTabTo('real_estate_data')"
              :aria-label="tabLabels.real_estate_data"
            >
              <v-tooltip bottom open-delay="200" :disabled="activeRouteName == 'real_estate_data'">
                <template #activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="d-inline-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21.891"
                height="24.212"
                class="ml-2"
                viewBox="0 0 21.891 24.212"
              >
                <g
                  id="Icon_feather-home"
                  data-name="Icon feather-home"
                  transform="translate(0.5 0.5)"
                >
                  <path
                    id="Path_3977"
                    data-name="Path 3977"
                    d="M4.5,11.124,14.945,3l10.445,8.124V23.891a2.321,2.321,0,0,1-2.321,2.321H6.821A2.321,2.321,0,0,1,4.5,23.891Z"
                    transform="translate(-4.5 -3)"
                    fill="none"
                    :stroke="activeRouteName == 'real_estate_data' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                  />
                  <path
                    id="Path_3978"
                    data-name="Path 3978"
                    d="M13.5,29.606V18h6.964V29.606"
                    transform="translate(-6.536 -6.394)"
                    fill="none"
                    :stroke="activeRouteName == 'real_estate_data' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                  />
                </g>
              </svg>
                  </span>
                </template>
                <span>{{ tabLabels.real_estate_data }}</span>
              </v-tooltip>
              <span v-if="activeRouteName == 'real_estate_data'">{{ tabLabels.real_estate_data }}</span>
            </v-tab>
            <v-tab
              :disabled="requestTabsDisabled"
              replace
              :style="
                activeRouteName == 'fund_data'
                  ? 'background-color: #40BE72; color: white; border-radius: 3px'
                  : ''
              "
              :to="detailsTabTo('fund_data')"
              :aria-label="tabLabels.fund_data"
            >
              <v-tooltip bottom open-delay="200" :disabled="activeRouteName == 'fund_data'">
                <template #activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="d-inline-flex">
              <svg
                class="ml-2"
                id="finance-report"
                xmlns="http://www.w3.org/2000/svg"
                width="20.223"
                height="23.212"
                viewBox="0 0 20.223 23.212"
              >
                <path
                  id="Path_2766"
                  data-name="Path 2766"
                  d="M73.167,28.241a.357.357,0,0,0-.256-.108H63.947a1.887,1.887,0,0,0-1.885,1.885v1.694h-2.7A1.887,1.887,0,0,0,57.478,33.6V49.46a1.887,1.887,0,0,0,1.885,1.885h11.87a1.887,1.887,0,0,0,1.885-1.885V47.766h2.7A1.887,1.887,0,0,0,77.7,45.882V33.057a.356.356,0,0,0-.1-.248Zm.1,1.128L76.5,32.7h-2.76a.474.474,0,0,1-.474-.474ZM72.4,49.461a1.173,1.173,0,0,1-1.171,1.171H59.363a1.173,1.173,0,0,1-1.171-1.171V33.6a1.173,1.173,0,0,1,1.171-1.171h2.7V45.882a1.887,1.887,0,0,0,1.885,1.885H72.4v1.694Zm3.413-2.408H63.947a1.173,1.173,0,0,1-1.171-1.171V30.018a1.173,1.173,0,0,1,1.171-1.171h8.608v3.38a1.188,1.188,0,0,0,1.187,1.187h3.246V45.882a1.173,1.173,0,0,1-1.171,1.171Z"
                  transform="translate(-57.478 -28.133)"
                  :fill="activeRouteName == 'fund_data' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                />
                <path
                  id="Path_2767"
                  data-name="Path 2767"
                  d="M207.593,110.417h-9.556a.357.357,0,0,0,0,.713h9.556a.357.357,0,1,0,0-.713Zm-9.556-1.525h5.721a.357.357,0,1,0,0-.713h-5.721a.357.357,0,0,0,0,.713Zm2.875-3.808h-.03a1.173,1.173,0,0,1-1.157-1.171.357.357,0,0,0-.713,0,1.887,1.887,0,0,0,1.528,1.85v.587a.357.357,0,1,0,.713,0v-.587a1.885,1.885,0,0,0-.357-3.735,1.171,1.171,0,1,1,1.171-1.171.357.357,0,1,0,.713,0,1.887,1.887,0,0,0-1.528-1.85V98.49a.357.357,0,0,0-.713,0v.517a1.885,1.885,0,0,0,.357,3.735,1.171,1.171,0,1,1,.015,2.343Z"
                  transform="translate(-190.539 -94.568)"
                  :fill="activeRouteName == 'fund_data' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                />
              </svg>
                  </span>
                </template>
                <span>{{ tabLabels.fund_data }}</span>
              </v-tooltip>
              <span v-if="activeRouteName == 'fund_data'">{{ tabLabels.fund_data }}</span>
            </v-tab>
            <v-tab
              :disabled="requestTabsDisabled"
              replace
              :style="
                activeRouteName == 'fund_calc'
                  ? 'background-color: #ead3eb; color: #0e807f; border-radius: 3px;font-weight: bold;'
                  : ''
              "
              :to="detailsTabTo('fund_calc')"
              :aria-label="tabLabels.fund_calc"
            >
              <!-- <svg
                class="ml-2"
                xmlns="http://www.w3.org/2000/svg"
                width="23.212"
                height="23.212"
                viewBox="0 0 23.212 23.212"
              >
                <path
                  id="calculator"
                  d="M5.748,7.858H6.8V8.913h0a.527.527,0,0,0,.528.527h0a.527.527,0,0,0,.527-.528V7.858H8.913a.528.528,0,1,0,0-1.055H7.858V5.748a.528.528,0,0,0-1.055,0V6.8H5.748a.528.528,0,0,0,0,1.055Zm.837,10.023L5.466,19a.527.527,0,1,0,.746.746l1.119-1.119L8.45,19.746A.527.527,0,0,0,9.2,19L8.076,17.881,9.2,16.762l.008-.008a.527.527,0,0,0-.754-.738L7.331,17.135,6.212,16.017,6.2,16.009a.527.527,0,1,0-.738.754ZM19.464,6.8H16.3a.528.528,0,0,0,0,1.055h3.165a.528.528,0,0,0,0-1.055ZM16.3,16.826h3.165a.528.528,0,0,0,0-1.055H16.3a.528.528,0,0,0,0,1.055ZM21.047,1H4.165A3.169,3.169,0,0,0,1,4.165V21.047a3.169,3.169,0,0,0,3.165,3.165H21.047a3.169,3.169,0,0,0,3.165-3.165V4.165A3.169,3.169,0,0,0,21.047,1ZM12.078,23.157H4.165a2.113,2.113,0,0,1-2.11-2.11V13.134H12.078Zm0-11.078H2.055V4.165a2.113,2.113,0,0,1,2.11-2.11h7.913Zm11.078,8.968a2.113,2.113,0,0,1-2.11,2.11H13.134V13.134H23.157Zm0-8.968H13.134V2.055h7.913a2.113,2.113,0,0,1,2.11,2.11ZM16.3,19.992h3.165a.528.528,0,0,0,0-1.055H16.3a.528.528,0,1,0,0,1.055Z"
                  transform="translate(-1 -1)"
                  :fill="$route.name == 'fund_calc' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                />
              </svg> -->
              <v-tooltip bottom open-delay="200" :disabled="activeRouteName == 'fund_calc'">
                <template #activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="d-inline-flex">
              <img src="@/assets/svg/calculator_new.svg" />
                  </span>
                </template>
                <span>{{ tabLabels.fund_calc }}</span>
              </v-tooltip>
              <span v-if="activeRouteName == 'fund_calc'" style="margin-right: 5px;;">{{ tabLabels.fund_calc }}</span>
            </v-tab>
            <v-tab
              :disabled="requestTabsDisabled"
              replace
              :style="
                activeRouteName == 'attachments'
                  ? 'background-color: #40BE72; color: white; border-radius: 3px'
                  : ''
              "
              :to="detailsTabTo('attachments')"
              :aria-label="tabLabels.attachments"
            >
              <v-tooltip bottom open-delay="200" :disabled="activeRouteName == 'attachments'">
                <template #activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="d-inline-flex">
              <svg
                class="ml-2"
                xmlns="http://www.w3.org/2000/svg"
                width="24.554"
                height="24.212"
                viewBox="0 0 24.554 24.212"
              >
                <g
                  id="Group_11393"
                  data-name="Group 11393"
                  transform="translate(-96.85 -4.02)"
                >
                  <g
                    id="Icon_feather-layers"
                    data-name="Icon feather-layers"
                    transform="translate(97.52 4.52)"
                  >
                    <path
                      id="Path_2763"
                      data-name="Path 2763"
                      d="M14.606,3,3,8.8l11.606,5.8L26.212,8.8Z"
                      transform="translate(-3 -3)"
                      fill="none"
                      :stroke="activeRouteName == 'attachments' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                    />
                    <path
                      id="Path_2764"
                      data-name="Path 2764"
                      d="M3,25.5l11.606,5.8,11.606-5.8"
                      transform="translate(-3 -8.091)"
                      fill="none"
                      :stroke="activeRouteName == 'attachments' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                    />
                    <path
                      id="Path_2765"
                      data-name="Path 2765"
                      d="M3,18l11.606,5.8L26.212,18"
                      transform="translate(-3 -6.394)"
                      fill="none"
                      :stroke="activeRouteName == 'attachments' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                    />
                  </g>
                </g>
              </svg>
                  </span>
                </template>
                <span>{{ tabLabels.attachments }}</span>
              </v-tooltip>
              <span v-if="activeRouteName == 'attachments'">{{ tabLabels.attachments }}</span>
            </v-tab>
            <v-tab
              :disabled="requestTabsDisabled"
              replace
              v-if="
                agent.type == 'رهن' || agent.type == 'تساهيل' || agent.type == 'شراء-دفعة' || agent.type == 'رهن-شراء'
              "
              :style="
                activeRouteName == 'prepayment'
                  ? 'background-color: #40BE72; color: white; border-radius: 3px'
                  : ''
              "
              :to="detailsTabTo('prepayment')"
              :aria-label="tabLabels.prepayment"
            >
              <v-tooltip bottom open-delay="200" :disabled="activeRouteName == 'prepayment'">
                <template #activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="d-inline-flex">
              <svg
                class="ml-2"
                xmlns="http://www.w3.org/2000/svg"
                width="24.554"
                height="24.212"
                viewBox="0 0 25.554 20.212"
              >
                <g
                  id="Group_11394"
                  data-name="Group 11394"
                  transform="translate(-90.85 -4.02)"
                >
                  <g
                    id="Icon_feather-credit-card"
                    data-name="Icon feather-credit-card"
                    transform="translate(89.57 -1.48)"
                  >
                    <path
                      id="Path_4082"
                      data-name="Path 4082"
                      d="M3.81,6H24.6a2.31,2.31,0,0,1,2.31,2.31V22.17a2.31,2.31,0,0,1-2.31,2.31H3.81A2.31,2.31,0,0,1,1.5,22.17V8.31A2.31,2.31,0,0,1,3.81,6Z"
                      fill="none"
                      :stroke="activeRouteName == 'prepayment' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                    />
                    <path
                      id="Path_4083"
                      data-name="Path 4083"
                      d="M1.5,15H26.91"
                      transform="translate(0 -2.07)"
                      fill="none"
                      :stroke="activeRouteName == 'prepayment' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                    />
                  </g>
                </g>
              </svg>
                  </span>
                </template>
                <span>{{ tabLabels.prepayment }}</span>
              </v-tooltip>

              <span v-if="activeRouteName == 'prepayment'">{{ tabLabels.prepayment }}</span>
            </v-tab>
            <v-tab
              :disabled="requestTabsDisabled"
              replace
              :style="
                activeRouteName == 'logs'
                  ? 'background-color: #40BE72; color: white; border-radius: 3px'
                  : ''
              "
              :to="detailsTabTo('logs')"
              :aria-label="tabLabels.logs"
            >
              <v-tooltip bottom open-delay="200" :disabled="activeRouteName == 'logs'">
                <template #activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="d-inline-flex">
              <svg
                class="ml-2"
                id="history_2_"
                data-name="history (2)"
                xmlns="http://www.w3.org/2000/svg"
                width="22.654"
                height="23.212"
                viewBox="0 0 22.654 23.212"
              >
                <path
                  id="Path_2774"
                  data-name="Path 2774"
                  d="M29.292,16.287H16.2a.454.454,0,1,1,0-.907H29.292a.454.454,0,1,1,0,.907Zm0,3.95H16.2a.454.454,0,0,1,0-.907H29.292a.454.454,0,1,1,0,.907Zm-8.309,3.955H16.194a.454.454,0,0,1,0-.907h4.789a.454.454,0,0,1,0,.907Zm-1.261,3.95H16.194a.454.454,0,0,1,0-.907h3.529a.454.454,0,1,1,0,.907Zm8.767,6.381A5.946,5.946,0,1,1,32.7,32.79,5.941,5.941,0,0,1,28.489,34.524Zm0-10.976a5.039,5.039,0,1,0,3.573,1.468A5.034,5.034,0,0,0,28.489,23.548Z"
                  transform="translate(-11.799 -11.312)"
                  :fill="activeRouteName == 'logs' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                />
                <path
                  id="Path_2775"
                  data-name="Path 2775"
                  d="M43.3,40.448a.454.454,0,0,1-.454-.454V37.274a.454.454,0,1,1,.907,0v2.721A.454.454,0,0,1,43.3,40.448Z"
                  transform="translate(-26.613 -23.028)"
                  :fill="activeRouteName == 'logs' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                />
                <path
                  id="Path_2776"
                  data-name="Path 2776"
                  d="M40.243,44.4H37.7a.454.454,0,1,1,0-.907h2.54a.454.454,0,1,1,0,.907Z"
                  transform="translate(-23.553 -26.673)"
                  :fill="activeRouteName == 'logs' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                />
                <path
                  id="Path_2777"
                  data-name="Path 2777"
                  d="M19.5,27.617H9.318A2.268,2.268,0,0,1,7.05,25.35V8.678A2.268,2.268,0,0,1,9.318,6.41H26.67a2.268,2.268,0,0,1,2.268,2.268v8.617a.454.454,0,1,1-.907,0V8.678A1.361,1.361,0,0,0,26.67,7.317H9.318A1.361,1.361,0,0,0,7.957,8.678V25.35A1.361,1.361,0,0,0,9.318,26.71H19.5a.454.454,0,1,1,0,.907Z"
                  transform="translate(-7.05 -6.41)"
                  :fill="activeRouteName == 'logs' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                />
              </svg>
                  </span>
                </template>
                <span>{{ tabLabels.logs }}</span>
              </v-tooltip>
              <span v-if="activeRouteName == 'logs'">{{ tabLabels.logs }}</span>
            </v-tab>
            <v-tab
              :disabled="requestTabsDisabled"
              replace
              :style="
                activeRouteName == 'tickets'
                  ? 'background-color: #40BE72; color: white; border-radius: 4px; height: 46px; margin-top: 2px;'
                  : ''
              "
              :to="detailsTabTo('tickets')"
              :aria-label="tabLabels.tickets"
            >
              <v-tooltip bottom open-delay="200" :disabled="activeRouteName == 'tickets'">
                <template #activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="d-inline-flex">
              <svg
                class="ml-2"
                xmlns="http://www.w3.org/2000/svg"
                width="23.194"
                height="23.212"
                viewBox="0 0 23.194 23.212"
              >
                <g id="ticket_menu" data-name="ticket menu" transform="translate(0)">
                  <path
                    id="Path_2758"
                    data-name="Path 2758"
                    d="M93.931,77.839a.631.631,0,0,0-.8-.076,2.521,2.521,0,0,1-3.493-3.506.638.638,0,0,0-.076-.795l-.725-.725A2.525,2.525,0,0,0,87.051,72h0a2.525,2.525,0,0,0-1.785.738L72.92,85.123a2.525,2.525,0,0,0,.006,3.563l.486.479a.636.636,0,0,0,.845.044,2.5,2.5,0,0,1,3.525,3.519.631.631,0,0,0,.038.851l.9.9a2.527,2.527,0,0,0,3.569,0h0l12.36-12.36a2.527,2.527,0,0,0,0-3.569ZM81.382,93.579a1.264,1.264,0,0,1-1.785,0l-.517-.517A3.758,3.758,0,0,0,73.929,87.9l-.107-.107a1.264,1.264,0,0,1,0-1.785l8.406-8.437,7.58,7.58Zm12.36-12.36L90.69,84.271l-7.58-7.586,3.039-3.052a1.24,1.24,0,0,1,.889-.372h0a1.26,1.26,0,0,1,.889.366l.385.385a3.788,3.788,0,0,0,5.064,5.064l.359.359a1.258,1.258,0,0,1,.006,1.785Z"
                    transform="translate(-72.187 -72)"
                    :fill="activeRouteName == 'tickets' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                  />
                  <path
                    id="Path_2759"
                    data-name="Path 2759"
                    d="M171.445,217.177l-3.058-3.058a1.264,1.264,0,0,0-1.785,0h0l-2.983,2.983a1.264,1.264,0,0,0,0,1.785l3.058,3.058a1.264,1.264,0,0,0,1.785,0l2.983-2.983a1.249,1.249,0,0,0,.032-1.772C171.47,217.177,171.463,217.171,171.445,217.177Zm-3.872,3.872-3.065-3.058,2.983-2.983h0l3.058,3.058Z"
                    transform="translate(-157.508 -204.811)"
                    :fill="activeRouteName == 'tickets' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                  />
                </g>
              </svg>
                  </span>
                </template>
                <span>{{ tabLabels.tickets }}</span>
              </v-tooltip>
              <span v-if="activeRouteName == 'tickets'" style="height: 38px; margin-top: 6px"
                >{{ tabLabels.tickets }}</span
              >
            </v-tab>

            <v-tab
              :disabled="requestTabsDisabled"
              replace
              :style="
                activeRouteName == 'calls'
                  ? 'background-color: #40BE72; color: white; border-radius: 4px; height: 46px; margin-top: 2px;'
                  : ''
              "
              :to="detailsTabTo('calls')"
              :aria-label="tabLabels.calls"
            >
              <!-- <svg
                class="ml-2"
                xmlns="http://www.w3.org/2000/svg"
                width="23.194"
                height="23.212"
                viewBox="0 0 23.194 23.212"
              >
                <g id="ticket_menu" data-name="ticket menu" transform="translate(0)">
                  <path
                    id="Path_2758"
                    data-name="Path 2758"
                    d="M93.931,77.839a.631.631,0,0,0-.8-.076,2.521,2.521,0,0,1-3.493-3.506.638.638,0,0,0-.076-.795l-.725-.725A2.525,2.525,0,0,0,87.051,72h0a2.525,2.525,0,0,0-1.785.738L72.92,85.123a2.525,2.525,0,0,0,.006,3.563l.486.479a.636.636,0,0,0,.845.044,2.5,2.5,0,0,1,3.525,3.519.631.631,0,0,0,.038.851l.9.9a2.527,2.527,0,0,0,3.569,0h0l12.36-12.36a2.527,2.527,0,0,0,0-3.569ZM81.382,93.579a1.264,1.264,0,0,1-1.785,0l-.517-.517A3.758,3.758,0,0,0,73.929,87.9l-.107-.107a1.264,1.264,0,0,1,0-1.785l8.406-8.437,7.58,7.58Zm12.36-12.36L90.69,84.271l-7.58-7.586,3.039-3.052a1.24,1.24,0,0,1,.889-.372h0a1.26,1.26,0,0,1,.889.366l.385.385a3.788,3.788,0,0,0,5.064,5.064l.359.359a1.258,1.258,0,0,1,.006,1.785Z"
                    transform="translate(-72.187 -72)"
                    :fill="$route.name == 'calls' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                  />
                  <path
                    id="Path_2759"
                    data-name="Path 2759"
                    d="M171.445,217.177l-3.058-3.058a1.264,1.264,0,0,0-1.785,0h0l-2.983,2.983a1.264,1.264,0,0,0,0,1.785l3.058,3.058a1.264,1.264,0,0,0,1.785,0l2.983-2.983a1.249,1.249,0,0,0,.032-1.772C171.47,217.177,171.463,217.171,171.445,217.177Zm-3.872,3.872-3.065-3.058,2.983-2.983h0l3.058,3.058Z"
                    transform="translate(-157.508 -204.811)"
                    :fill="$route.name == 'calls' ? '#fff' : ($store.getters.isDark ? '#fff' : '#2c2c2c')"
                  />
                </g>
              </svg> -->
              <v-tooltip bottom open-delay="200" :disabled="activeRouteName == 'calls'">
                <template #activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="d-inline-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 23.194 23.212"
                width="30.194"
                height="30.212"
                fill="none"
                :stroke="$store.getters.isDark ? '#fff' : 'currentColor'"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15h-2v-2h2v2zm4 0h-2v-2h2v2zm2-4h-6V4h6v9z"
                />
              </svg>
                  </span>
                </template>
                <span>{{ tabLabels.calls }}</span>
              </v-tooltip>
              <span v-if="activeRouteName == 'calls'" style="height: 38px; margin-top: 6px"
                >{{ tabLabels.calls }}</span
              >
            </v-tab>
          </v-tabs>
          <div v-if="CurrentRole == 7">
            <v-btn
                color="primary"
                elevation="2"
                outlined
                small
                @click="show_Field_log('move_request_reason')"
              >
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14.513"
                  height="16.448"
                  viewBox="0 0 14.513 16.448"
                >
                  <path
                    id="Icon_material-subdirectory-arrow-right"
                    :fill="$store.getters.isDark ? '#ffffff' : '#000000'"
                    data-name="Icon material-subdirectory-arrow-right"
                    d="M20.513,16.643l-5.805,5.805-1.374-1.374,3.473-3.464H6V6H7.935v9.675h8.872l-3.473-3.464,1.374-1.374Z"
                    transform="translate(-6 -6)"
                  />
                </svg>
                <!-- سجل نقل الطلب -->
              </v-btn>
          </div>
          <div v-if="CurrentRole == 2">
            <FundingReciveIcon  @sendRequstToAdmin="sendRequstToAdmin"/>
            <AgentSendPaymentDialog :reqId="$route.params.id" />
            <ValidationAsDialog />

            <FMRejectRequestDialog :reqId="$route.params.id"/>
            <FMSendRequestDialog :reqId="$route.params.id"/>
            <FMApproveRequestDialog :reqId="$route.params.id"/>
            <FMCancelPaymentDialog :reqId="$route.params.id"/>
            <FMSendPaymentDialog :reqId="$route.params.id"/>
            <FMSendRequestToBankDialog :reqId="$route.params.id"/>
            <FMCreatePaymentDialog :reqId="$route.params.id" :requestData="agent"/>

            <DosentWantOurProductDialog  @sendRequstToAdmin="sendRequstToAdmin" />
          </div>
          <div v-else-if="isRole16 && !cannotUpdateRequest">
            <ReciveIcon @sendRequstToAdmin="sendRequstToAdmin" />
            <ValidationAsDialog />
            <DosentWantOurProductDialog @sendRequstToAdmin="sendRequstToAdmin" />
          </div>
          <div v-else-if="!isAdmin && !cannotUpdateRequest">
            <ReciveIcon  
              @sendRequstToAdmin="sendRequstToAdmin"
              @reject-request="showRejectDialog = true"
            />
            <AgentSendPaymentDialog :reqId="$route.params.id" />
            <ValidationAsDialog />
            <DosentWantOurProductDialog  @sendRequstToAdmin="sendRequstToAdmin" />
            <AgentRejectRequestDialog 
              v-if="isRole0NotCustomerService"
              v-model="showRejectDialog"
              :req-id="$route.params.id"
              :request-info="agent"
              @confirmed="handleRequestRejected"
            />
          </div>
          <div
            v-else-if="CurrentRole == 7"
            style="margin-bottom: 22px; margin-left: 15px"
          >
            <AdminProcess />
          </div>
        </div>
      </v-sheet>

      <!-- for emitting event to re-execute get_request_details() function  -->
      <router-view :agent.sync="agent" />
      
      <!-- Fixed Icon Button for Request Stations Timeline -->
      <v-btn
        fab
        :color="$vuetify.theme.themes.light.dialogActionBTN || '#451646'"
        @click="showStationsDialog = true"
        v-if="CurrentRole == 7 && false"
        class="my-10"
        style="position: fixed; left: -16px; bottom: 0px; z-index: 1000"
        title="سجل محطات الطلب"
      >
        <v-icon color="white" size="28">mdi-history</v-icon>
      </v-btn>

      <!-- Request Stations Dialog -->
      <v-dialog
        v-model="showStationsDialog"
        max-width="1200"
        scrollable
        persistent
      >
        <v-card>
          <v-card-title class="text-h5" style="background-color: #451646; color: white;">
            <span>سجل محطات الطلب حسب المستخدم</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="showStationsDialog = false" color="white">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="padding: 0;">
            <RequestStationsByUser 
              v-if="showStationsDialog && $route.params.id"
              :request-id="$route.params.id"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- بيانات الطلب -->
      <v-sheet class="px-3 pb-3 mt-3 pt-3">
        <div
          class="d-flex align-center justify-center py-3"
          style="
            font-size: 18px;
            color: white;
            background-color: #451646;
            cursor: pointer;
            padding-bottom: 10px !important;
            border-radius: 4px;
          "
        >
          بيانات الطلب
        </div>
        <v-form style="background: none; color: #000" :disabled="requestFieldsDisabled">
          <v-card flat class="mt-3">
            <v-layout
              row
              wrap
              style="background-color: #f3f5f7"
              class="userProfile__container"
            >
              <!-- =================================================================== -->
              <!-- بيانات الطلب -->
              <!-- =================================================================== -->
              <v-col cols="12" lg="4" md="4" sm="6" xs="12">
                <v-card class="pa-3 position-relative userProfile__card">
                  
                  <!-- =================================================================== -->
                  <!-- نوع الطلب -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group" id="reqtyp">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="checkClickNumberReqType()"
                        />
                        نوع الطلب
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="reqTypes"
                        hide-details
                        v-model="agent.type"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="requestFieldsDisabled"
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->


                  <!-- =================================================================== -->
                  <!-- المنتج المختار -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group" id="req_product_type">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('req_product_type')"
                        />
                        المنتج المختار 
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="productTypeItems"
                        hide-details
                        v-model="productTypeModel"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="requestFieldsDisabled"
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  <!-- =================================================================== -->
                  <!-- طلب العميل - مخفي عند الاستشاري
                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group" id="customer_request_type_id">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                          class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('customer_request_type')"
                        />
                        طلب العميل
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.customer_request_types"
                        hide-details
                        v-model="agent.customer_request_type_id"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  -->

                  <!-- =================================================================== -->
                  <!-- وصف الطلب -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12" v-if="agent.request_description_other == null">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('request_description_id')"
                        />
                        وصف الطلب
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.request_descriptions"
                        hide-details
                        v-model="agent.request_description_id"
                        item-text="option"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                        disabled
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->


                  <!-- =================================================================== -->
                  <!-- وصف أخر لطلبك -->
                  <!-- =================================================================== -->  
                  <v-col cols="12" sm="12" v-else>
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="checkClickNumberComment()"
                        />
                        وصف أخر لطلبك
                      </div>
                      <div class="horizontal__line"></div>

                      <v-textarea
                        hide-details
                        v-model="agent.request_description_other"
                        class="mr-1"
                        outlined
                        dense
                        disabled
                      >
                      </v-textarea>
                    </div>
                  </v-col>
                  <!-- ==================================================== -->
                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img src="@/assets/icons/material-history.svg" class="material-history-icon" alt="image"
                          style="margin-top: 5px; margin-left: 5px" @click="show_Field_log('call_time')" />
                        الوقت المناسب للتواصل
                      </div>
                      <div class="horizontal__line"></div>
                    
                        <!-- <v-text-field
                          v-model="formattedCallTime"
                          type="datetime-local"
                          @change="validateCallTime(agent.customer.call_time)"
                          :error-messages="callTimeError ? [callTimeError] : []"
                          style="margin-top: 15px"
                          outlined
                          dense
                        ></v-text-field> -->

                        <v-autocomplete
                        :items="callTimeItems"
                        item-text="value"
                        item-value="id"
                        v-model="selectedCallTime" name="call_time" id="call_time" style="margin-top: 15px" outlined dense>
                        <template v-slot:item="{ item, attrs, on }">
                          <v-list-item v-bind="attrs" v-on="on">
                            <v-list-item-title :id="attrs['aria-labelledby']" v-text="item.value"></v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-autocomplete>


                    </div>
                    <span v-if="callTimeError" class="text-danger" style="color: red;" id="callTimeError" role="alert"> {{ callTimeError }}
                    </span>
                  </v-col>
                  <!-- =================================================================== -->
                  <!-- <v-col cols="12" sm="12">
                    <v-card class="px-3 position-relative userProfile__card">
                      <div class="switch__container">
                        <div>
                          <img
                            src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                            alt="image"
                            style="margin-left: 5px"
                            @click="show_Field_log('possible_to_sell_to_customer')"
                          />
                          هل بالامكان البيع للعميل؟
                        </div>
                        <div>
                          <v-radio-group
                            row
                            v-model="agent.possible_to_sell_to_customer"
                            :disabled="requestFieldsDisabled"
                          >
                            <v-radio value="1" label="نعم"></v-radio>
                            <v-radio value="0" label="لا"></v-radio>
                          </v-radio-group>
                        </div>
                        <hr style="border: 0.5px solid #38414a26; margin-bottom: 0px" />
                      </div>
                      </v-card>
                  </v-col> -->
                </v-card>
              </v-col>
              <!-- =================================================================== -->


              <!-- start Mortgage settings => khaled -->

              <!-- =================================================================== -->
              <!-- احتياجات العميل -->
              <!-- =================================================================== -->
              <v-col cols="12" lg="4" md="4" sm="6" xs="12" v-if="agent.type == 'رهن' ">
                <v-card class="pa-3 position-relative userProfile__card">
                  <!-- =================================================================== -->
                  <!-- احتياجات العميل -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group" id="customer_needs_id">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('customer_needs_id')"
                        />
                         احتياجات العميل
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.customer_needs"
                        hide-details
                        v-model="agent.customer_needs_id"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="requestFieldsDisabled"
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->
                  
                  <!-- =================================================================== -->
                  <!-- الاعتراضات والتحديات -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group" id="objections_challenges_id">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('objections_challenges_id')"
                        />
                         الاعتراضات والتحديات
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.objections_challenges"
                        hide-details
                        v-model="agent.objections_challenges_id"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="requestFieldsDisabled"
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>

                  <!-- =================================================================== -->
                  <!-- المعوقات -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group" id="obstacles_id">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('obstacles_id')"
                        />
                          المعوقات
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.obstacles"
                        hide-details
                        v-model="agent.obstacles_id"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="requestFieldsDisabled"
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                </v-card>
              </v-col>
              <!-- =================================================================== -->

              <!-- end Mortgage settings => khaled -->


              <!-- =================================================================== -->
              <!-- مصدر المعاملة -->
              <!-- =================================================================== -->
              <v-col cols="12" lg="4" md="4" sm="6" xs="12">
                <v-card class="pa-3 position-relative userProfile__card">
                  
                  <!-- =================================================================== -->
                  <!-- مصدر المعاملة -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12"  v-if="selected.includes(parseInt(CurrentRole))">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('reqSource')"
                        />
                        مصدر المعاملة
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.work_sources"
                        hide-details
                        v-model="agent.source"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        :disabled="requestSourceDisabled"
                        class="mr-1"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  <!-- =================================================================== -->
                  <!-- اسم المتعاون -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12" v-if="agent.source == '2' && selected.includes(parseInt(CurrentRole))">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="checkClickNumberSource()"
                        />
                        اسم المتعاون
                      </div>
                      <div class="horizontal__line"></div>

                      <v-text-field
                        hide-details
                        v-model="agent.collaborator_name"
                        :disabled="agent.collaborator_id != null"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                      >
                      </v-text-field>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  <!-- =================================================================== -->
                  <!-- تصنيف المعامله -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12" v-if="!isCustomerServiceUser">
                    <div style="display: flex; align-items: center" class="input__group" id="class_agent">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="checkClickNumberClassAgent()"
                        />
                        تصنيف المعامله 
                      </div>
                      <div class="horizontal__line"></div>

                      <v-autocomplete
                        :items="$store.state.request_class"
                        hide-details
                        v-model="agent.class_id_agent"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        @click="disableLifted"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="requestFieldsDisabled"
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  <!-- =================================================================== -->
                  <!-- أول تصنيف على الطلب -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12" v-if="CurrentRole == 7">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>أول تصنيف على الطلب</div>
                      <div class="horizontal__line"></div>
                      <v-text-field
                        hide-details
                        :value="firstClassificationDisplay"
                        class="mr-1"
                        outlined
                        dense
                        disabled
                        readonly
                      />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  <!-- =================================================================== -->
                  <!-- سورس الحملة -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12" v-if="CurrentRole == 7">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>سورس الحملة</div>
                      <div class="horizontal__line"></div>
                      <v-text-field
                        hide-details
                        :value="campaignSourceDisplay"
                        class="mr-1"
                        outlined
                        dense
                        disabled
                        readonly
                      />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  <!-- =================================================================== -->
                  <!-- سبب الرفض -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12" v-if="isRejectedClass(agent.class_id_agent)">
                    <div style="display: flex; align-items: center" class="input__group" id="rejection_id_agent">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="checkClickNumberRejectionAgent()"
                        />
                        سبب الرفض
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete
                        :items="$store.state.rejection_list"
                        hide-details
                        v-model="agent.rejection_id_agent"
                        item-text="title"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="requestFieldsDisabled"
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  <!-- =================================================================== -->
                  <!-- سبب رفض الاستشاري -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12" v-if="showAgentRejection && isRejectedClass(agent.class_id_agent)">
                    <div style="display: flex; align-items: center" class="input__group" id="rejection_id_agent">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="checkClickNumberRejectionAgent()"
                        />
                        سبب رفض الاستشاري
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete
                        :items="$store.state.rejection_list"
                        hide-details
                        v-model="agent.rejection_id_agent"
                        item-text="title"
                        item-value="id"
                        :placeholder="!agent.req_product_type ? 'يجب اختيار نوع المنتج اولا' : ''"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="requestFieldsDisabled"
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  <!-- =================================================================== -->
                  <!-- هل بالامكان البيع للعميل؟ -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12">
                    <div class="switch__container" id="possible_to_sell_to_customer">
                      <div class="mb-2">
                        <svg
                          @click="show_Field_log('possible_to_sell_to_customer')"
                          xmlns="http://www.w3.org/2000/svg"
                          width="15.76"
                          height="12.964"
                          viewBox="0 0 15.76 12.964"
                          style="margin-left: 3px; cursor: pointer; margin-bottom: -2px"
                        >
                          <path
                            id="Icon_material-history"
                            data-name="Icon material-history"
                            d="M10.506,4.5a6.623,6.623,0,0,0-6.754,6.482H1.5l2.919,2.8.053.1,3.032-2.9H5.252A5.147,5.147,0,0,1,10.506,5.94a5.147,5.147,0,0,1,5.253,5.042,5.147,5.147,0,0,1-5.253,5.042A5.322,5.322,0,0,1,6.8,14.54L5.733,15.563a6.864,6.864,0,0,0,4.773,1.9,6.623,6.623,0,0,0,6.754-6.482A6.623,6.623,0,0,0,10.506,4.5Zm-.75,3.6v3.6l3.212,1.829.54-.871-2.627-1.5V8.1Z"
                            transform="translate(-1.5 -4.5)"
                          />
                        </svg>
                        هل بالامكان البيع للعميل؟
                      </div>
                      <v-radio-group
                        row
                        v-model="agent.possible_to_sell_to_customer"
                        class="mr-n4 px-0"
                      >
                        <v-radio value="1" label="نعم"></v-radio>
                        <v-radio value="0" label="لا"></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                  <!-- =================================================================== -->
                </v-card>
              </v-col>
              <!-- =================================================================== -->

              <!-- =================================================================== -->
              <!-- تصنيف خدمة العملاء والملاحظات-->
              <!-- =================================================================== -->
              <v-col cols="12" lg="4" md="4" sm="6" xs="12">
                <v-card class="pa-3 position-relative userProfile__card">
                  
                  <!-- =================================================================== -->
                  <!-- تصنيف خدمة العملاء — read-only for الاستشاري: the CS pool is not
                       theirs to edit, but they need to see what خدمة العملاء recorded. -->
                  <!-- =================================================================== -->
                  <AgentClassificationLabelComponent
                    v-if="isRole0NotCustomerService"
                    anchor-id="class_id_cs_readonly"
                    label="تصنيف خدمة العملاء"
                    fallback="لم يتم تصنيف خدمة العملاء"
                    :id="agent.class_id_cs"
                    :text="agent.class_id_cs_text"
                  />
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12" v-if="showBothRejections">
                    <div style="display: flex; align-items: center" class="input__group" id="class_id_cs">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('class_id_cs')"
                        />
                        تصنيف خدمة العملاء
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete
                        :items="$store.state.cs_request_class"
                        hide-details
                        v-model="agent.class_id_cs"
                        item-text="value"
                        item-value="id"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="requestFieldsDisabled"
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  <!-- =================================================================== -->
                  <!-- سبب رفض خدمة العملاء -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12" v-if="showCsRejection && isRejectedClass(agent.class_id_cs)">
                    <div style="display: flex; align-items: center" class="input__group" id="rejection_id_cs">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('rejection_id_cs')"
                        />
                        سبب رفض خدمة العملاء
                      </div>
                      <div class="horizontal__line"></div>
                      <v-autocomplete
                        :items="$store.state.rejection_list"
                        hide-details
                        v-model="agent.rejection_id_cs"
                        item-text="title"
                        item-value="id"
                        :placeholder="!agent.req_product_type ? 'يجب اختيار نوع المنتج اولا' : ''"
                        style="border: none !important"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="requestFieldsDisabled"
                      >
                      </v-autocomplete>
                      <img src="@/assets/icons/down-arrow.svg" />
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  <!-- =================================== notes =================================== -->
                  <div style="margin-bottom: 15px; margin-left: 10px">
                    <span
                      @click="
                        TempNote = agent.agent_notes;
                        agent.agent_notes = '';
                      "
                      style="float: left"
                      v-if="agent.agent_notes != ''"
                    >
                      clear
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                      >
                        <g
                          id="Icon_ionic-ios-close-circle-outline"
                          data-name="Icon ionic-ios-close-circle-outline"
                          transform="translate(-3.375 -3.375)"
                        >
                          <path
                            id="Path_5867"
                            data-name="Path 5867"
                            d="M19.089,18.109l-2.28-2.28,2.28-2.28a.691.691,0,1,0-.978-.978l-2.28,2.28-2.28-2.28a.691.691,0,0,0-.978.978l2.28,2.28-2.28,2.28a.669.669,0,0,0,0,.978.687.687,0,0,0,.978,0l2.28-2.28,2.28,2.28a.7.7,0,0,0,.978,0A.687.687,0,0,0,19.089,18.109Z"
                            transform="translate(-3.456 -3.454)"
                            fill="#2c2c2c"
                          />
                          <path
                            id="Path_5868"
                            data-name="Path 5868"
                            d="M12.375,4.587a7.785,7.785,0,1,1-5.508,2.28,7.737,7.737,0,0,1,5.508-2.28m0-1.212a9,9,0,1,0,9,9,9,9,0,0,0-9-9Z"
                            fill="#2c2c2c"
                          />
                        </g>
                      </svg>
                    </span>
                    <span
                      @click="
                        agent.agent_notes = TempNote;
                        TempNote = '';
                      "
                      style="float: left"
                      v-if="TempNote != '' && agent.agent_notes == ''"
                    >
                      undo
                      <v-icon small>mdi-undo</v-icon>
                    </span>
                  </div>
                  <!-- =========================================================================== -->


                  <!-- =================================================================== -->
                  <!-- الملاحظة -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group" id="comment">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="checkClickNumberComment()"
                        />
                        الملاحظة
                      </div>
                      <div class="horizontal__line"></div>

                      <v-textarea
                        hide-details
                        v-model="agent.agent_notes"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="morPurFieldsDisabled"
                      >
                      </v-textarea>
                    </div>
                  </v-col>
                  <!-- =================================================================== -->
                  
                  <!-- =================================================================== -->
                  <!-- ملاحظة موظف الجودة -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12" v-if="CurrentRole == 5">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('quacomment')"
                        />
                        ملاحظة موظف الجودة
                      </div>
                      <div class="horizontal__line"></div>

                      <v-textarea
                        hide-details
                        v-model="agent.quacomment"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="CurrentRole != 7"
                      >
                      </v-textarea>
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  <!-- =================================================================== -->
                  <!-- ملاحظة خدمة العملاء -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('customer_service_note')"
                        />
                        ملاحظة خدمة العملاء
                      </div>
                      <div class="horizontal__line"></div>

                      <v-textarea
                        hide-details
                        style="background-color: white"
                        v-model="agent.customer_service_note"
                        class="mr-1"
                        outlined
                        dense
                      >
                      </v-textarea>
                    </div>
                  </v-col>
                  <!-- =================================================================== -->


                  <!-- =================================================================== -->
                  <!-- ملاحظة مدير التمويل -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12" v-if="[0, 1, 2, 7].includes(parseInt(CurrentRole))">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('funding_manager_note')"
                        />
                        ملاحظة مدير التمويل
                      </div>
                      <div class="horizontal__line"></div>

                      <v-textarea
                        hide-details
                        style="background-color: white"
                        v-model="agent.funding_manager_note"
                        class="mr-1"
                        outlined
                        dense
                      >
                      </v-textarea>
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  <!-- =================================================================== -->
                  <!-- ملاحظة المتعاون -->
                  <!-- =================================================================== -->
                  <v-col cols="12" sm="12" v-if="agent.source == '2'">
                    <div style="display: flex; align-items: center" class="input__group">
                      <div>
                        <img
                          src="@/assets/icons/material-history.svg"
                        class="material-history-icon"
                          alt="image"
                          style="margin-top: 5px; margin-left: 5px"
                          @click="show_Field_log('collaborator_notes')"
                        />
                        ملاحظة المتعاون
                      </div>
                      <div class="horizontal__line"></div>

                      <v-textarea
                        hide-details
                        v-model="agent.collaborator_notes"
                        class="mr-1"
                        outlined
                        dense
                        :disabled="agent.collaborator_id == null"
                      >
                      </v-textarea>
                    </div>
                  </v-col>
                  <!-- =================================================================== -->

                  
                  
                  <!-- =================================================================== -->
                  <!-- رقم البنك -->
                  <!-- =================================================================== -->
                  <div v-if="CurrentRole == 2">
                    <v-col cols="12" sm="12">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img
                            src="@/assets/icons/material-history.svg"
                          class="material-history-icon"
                            alt="image"
                            style="margin-top: 5px; margin-left: 5px"
                            @click="show_Field_log('reqNoBank')"
                          />
                          رقم البنك
                        </div>
                        <div class="horizontal__line"></div>

                        <v-textarea
                          hide-details
                          v-model="agent.reqNoBank"
                          class="mr-1"
                          outlined
                          dense
                          :disabled="morPurFieldsDisabled"
                        >
                        </v-textarea>
                      </div>
                    </v-col>


                    <v-col cols="12" sm="12">
                      <div style="display: flex; align-items: center" class="input__group">
                        <div>
                          <img
                            src="@/assets/icons/material-history.svg"
                          class="material-history-icon"
                            alt="image"
                            style="margin-top: 5px; margin-left: 5px"
                            @click="show_Field_log('empBank')"
                          />
                          موظف البنك
                        </div>
                        <div class="horizontal__line"></div>

                        <v-textarea
                          hide-details
                          v-model="agent.empBank"
                          class="mr-1"
                          outlined
                          dense
                          :disabled="morPurFieldsDisabled"
                        >
                        </v-textarea>
                      </div>
                    </v-col>
                 </div>
                 <!-- =================================================================== -->
                </v-card>
              </v-col>
              <!-- =================================================================== -->


              <!-- =================================== =================================== -->
              <!-- inputs shows when open request in new tab -->
              <v-col cols="12" lg="4" md="4" sm="6" xs="12" v-if="showCustomerSituationFixFields">
                <v-card class="pa-3 position-relative userProfile__card">
                  <v-row dense>
                    <v-col cols="12">
                      <div style="display: flex; align-items: center; gap: 6px" class="input__group" id="mortgage_duration_id">
                        <div>
                          <img
                            src="@/assets/icons/material-history.svg"
                            class="material-history-icon"
                            alt="image"
                            style="margin-top: 5px; margin-left: 5px"
                            @click="show_Field_log('mortgage_duration_id')"
                          />
                          متي يظبط العميل حاله 
                        </div>
                        <div class="horizontal__line"></div>
                        <v-autocomplete
                          :items="$store.state.mortgageDurations || []"
                          :rules="customerSituationDurationRules"
                          hide-details="auto"
                          v-model="agent.mortgage_duration_id"
                          item-text="label"
                          item-value="id"
                          style="border: none !important"
                          class="mr-1"
                          outlined
                          dense
                          clearable
                          :disabled="requestFieldsDisabled"
                        >
                        </v-autocomplete>
                        <img src="@/assets/icons/down-arrow.svg" />
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div style="display: flex; align-items: center; gap: 6px" class="input__group" id="situation_improve_date">
                        <div>
                          <img
                            src="@/assets/icons/material-history.svg"
                            class="material-history-icon"
                            alt="image"
                            style="margin-top: 5px; margin-left: 5px"
                            @click="show_Field_log('situation_improve_date')"
                          />
                          تاريخ ظبط العميل لحاله
                        </div>
                        <div class="horizontal__line"></div>
                        <v-text-field
                          type="date"
                          :min="todayDateFormat"
                          :rules="customerSituationDateRules"
                          hide-details="auto"
                          v-model="agent.situation_improve_date"
                          class="mr-1"
                          outlined
                          dense
                          :disabled="requestFieldsDisabled"
                          append-icon
                        >
                          <template v-slot:append>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17.396"
                              height="16.989"
                              viewBox="0 0 17.396 16.989"
                              style="margin-top: 4px"
                            >
                              <path
                                d="M19.1,24.906H6.714a2.5,2.5,0,0,1-2.5-2.5V16.412a.626.626,0,0,1,1.252,0V22.4a1.252,1.252,0,0,0,1.252,1.252H19.1A1.252,1.252,0,0,0,20.354,22.4V11.814A1.252,1.252,0,0,0,19.1,10.562H6.714a1.252,1.252,0,0,0-1.252,1.252V14.28a.626.626,0,0,1-1.252,0V11.814a2.5,2.5,0,0,1,2.5-2.5H19.1a2.5,2.5,0,0,1,2.5,2.5V22.4A2.5,2.5,0,0,1,19.1,24.906Z"
                                transform="translate(-4.21 -7.917)"
                                fill="#6c757d"
                              />
                              <path
                                d="M18.476,11.849H4.836a.626.626,0,1,1,0-1.252h13.64a.626.626,0,0,1,0,1.252ZM9.23,8.9A.626.626,0,0,1,8.6,8.275V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,9.23,8.9Zm7.355,0a.626.626,0,0,1-.626-.626V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,16.585,8.9Z"
                                transform="translate(-4.21 -4.86)"
                                fill="#6c757d"
                              />
                            </svg>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <!-- =================================== =================================== -->

            </v-layout>
          </v-card>
        </v-form>
      </v-sheet>
      <v-sheet class="px-5 py-5 mt-3 mb-10">
        <v-form :disabled="requestFieldsDisabled">
          <v-row>
            <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="my-2">
              <div class="mb-2">تاريخ الطلب</div>
              <v-text-field
                type="date"
                :min="todayDateFormat"
                :max="isPostponedCommunicationClassId(agent.class_id_agent) ? postponedMaxFollowUpDate : null"
                hide-details
                v-model="agent.follow_date"
                class="mr-1"
                outlined
                dense
                append-icon
              >
                <template v-slot:append>
                  <svg
                    id="calendar"
                    xmlns="http://www.w3.org/2000/svg"
                    width="17.396"
                    height="16.989"
                    viewBox="0 0 17.396 16.989"
                    style="margin-top: 4px"
                  >
                    <path
                      id="Path_2784"
                      data-name="Path 2784"
                      d="M19.1,24.906H6.714a2.5,2.5,0,0,1-2.5-2.5V16.412a.626.626,0,0,1,1.252,0V22.4a1.252,1.252,0,0,0,1.252,1.252H19.1A1.252,1.252,0,0,0,20.354,22.4V11.814A1.252,1.252,0,0,0,19.1,10.562H6.714a1.252,1.252,0,0,0-1.252,1.252V14.28a.626.626,0,0,1-1.252,0V11.814a2.5,2.5,0,0,1,2.5-2.5H19.1a2.5,2.5,0,0,1,2.5,2.5V22.4A2.5,2.5,0,0,1,19.1,24.906Z"
                      transform="translate(-4.21 -7.917)"
                      fill="#6c757d"
                    />
                    <path
                      id="Path_2785"
                      data-name="Path 2785"
                      d="M18.476,11.849H4.836a.626.626,0,1,1,0-1.252h13.64a.626.626,0,0,1,0,1.252ZM9.23,8.9A.626.626,0,0,1,8.6,8.275V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,9.23,8.9Zm7.355,0a.626.626,0,0,1-.626-.626V5.486a.626.626,0,1,1,1.252,0V8.275A.626.626,0,0,1,16.585,8.9Z"
                      transform="translate(-4.21 -4.86)"
                      fill="#6c757d"
                    />
                  </svg>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="my-2">
              <div class="mb-2">توقيت الطلب</div>
              <v-text-field
                type="time"
                hide-details
                v-model="agent.follow_time"
                outlined
                dense
                append-icon
                class="follow-req-time mr-1"
              >
                <template v-slot:append>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17.989"
                    height="17.989"
                    viewBox="0 0 17.989 17.989"
                    style="margin-top: 4px; cursor: pointer"
                  >
                    <g
                      id="Icon_feather-clock"
                      data-name="Icon feather-clock"
                      transform="translate(-2.5 -2.5)"
                    >
                      <path
                        id="Path_4042"
                        data-name="Path 4042"
                        d="M19.989,11.494A8.494,8.494,0,1,1,11.494,3,8.494,8.494,0,0,1,19.989,11.494Z"
                        fill="none"
                        stroke="#6c757d"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1"
                      />
                      <path
                        id="Path_4043"
                        data-name="Path 4043"
                        d="M18,9v5.1l3.4,1.7"
                        transform="translate(-6.506 -2.602)"
                        fill="none"
                        stroke="#6c757d"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1"
                      />
                    </g>
                  </svg>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-sheet>
      <v-sheet
        v-if="activeRouteName == 'agent_data' || 
              activeRouteName == 'real_estate_data' || 
              activeRouteName == 'fund_data' || 
              activeRouteName == 'fund_calc' || 
              activeRouteName == 'attachments' || 
              activeRouteName == 'prepayment' || 
              activeRouteName == 'logs' || 
              activeRouteName == 'tickets' || 
              activeRouteName == 'calls'"
        class="footer__container"
        elevation="5"
        style="
          position: sticky;
          background: #451646;
          color: white;
          bottom: 5px;
          left: 32px;
          right: 32px;
          drop-shadow: #00000014;
          opacity: 100%;
          height: 56px;
          padding: 15px;
          display: flex;
          align-items: center;
        "
      >
        <span class="my-5" style="display: inline">{{ agent.req_date }}</span>
        <v-divider class="mx-5" vertical />
        <span class="my-5" style="display: flex">
          <span style="margin-top: 7px"> تصنيف المعاملة :</span>
          <v-autocomplete
            :items="$store.state.request_class"
            hide-details
            v-model="agent.class_id_agent"
            item-text="value"
            item-value="id"
            style="border: none !important;background-color: white;"
            @click="disableLifted"
            class="mr-1"
            outlined
            dense
            :disabled="requestFieldsDisabled"
          >
          </v-autocomplete>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11.457"
            height="6.328"
            viewBox="0 0 11.457 6.328"
            style="margin-top: 18px; margin-right: -20px"
          >
            <path
              id="Icon_ionic-ios-arrow-down"
              data-name="Icon ionic-ios-arrow-down"
              d="M11.918,15.667l4.332-4.188a.836.836,0,0,1,1.156,0,.778.778,0,0,1,0,1.12L12.5,17.344a.838.838,0,0,1-1.129.023L6.426,12.6a.776.776,0,0,1,0-1.12.836.836,0,0,1,1.156,0Z"
              transform="translate(-6.188 -11.246)"
              fill="white"
            />
          </svg>

          <!-- تصنيف المعاملة : {{ getAgentClass || "لايوجد" }} -->
        </span>
        <v-divider class="mx-5" vertical />
      
        <span class="my-5" style="display: flex">
          <span style="margin-top: 7px"> الملاحظة :</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                v-on="on"
                hide-details
                v-model="agent.agent_notes"
                class="mr-1"
                outlined
                dense
                style="background-color: white"
              >
              </v-text-field>
            </template>
            
            <div style="background-color: white; color: black; padding: 10px; border-radius: 4px; box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);">
              {{ agent.agent_notes }}
            </div>
          </v-tooltip>
        </span>
        <v-divider class="mx-5" vertical />
        
        <!-- Khaled -->
        <span class="my-5" style="display: flex" v-if="agent.user">
          <span style="margin-top: 7px"> استشاري المبيعات :</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                v-on="on"
                hide-details
                v-model="agent.user.name"
                class="mr-1"
                dense
                style="background-color: white"
                disabled
              >
              </v-text-field>
            </template>

            <div style="background-color: white; color: black; padding: 10px; border-radius: 4px">
              {{ agent.user.name }}
            </div>
          </v-tooltip>
        </span>
        <span class="my-5" style="display: flex" v-if="agent.customer_service">
          <span style="padding-top: 10px"> خدمة العملاء :</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                v-on="on"
                hide-details
                v-model="agent.customer_service.name"
                class="mr-1"
                dense
                style="background-color: white; padding-top: 0px !important;"
                disabled
              >
              </v-text-field>
            </template>

            <div style="background-color: white; color: black; padding: 10px; border-radius: 4px">
              {{ agent.customer_service?.name }}
            </div>
          </v-tooltip>
        </span>
        <v-divider class="mx-5" vertical />

        <span class="my-5" style="display: flex">
          <span style="margin-top: 7px"> حالة الطلب :</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                v-on="on"
                hide-details
                v-model="agent.status"
                class="mr-1"
                outlined
                dense
                style="background-color: white"
                disabled
              >
              </v-text-field>
            </template>
            
            <div style="background-color: white; color: black; padding: 10px; border-radius: 4px; box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);">
              {{ agent.status }}
            </div>
          </v-tooltip>
        </span>


      </v-sheet>
      
      <v-dialog
        v-model="$store.state.save_result_dialog"
        persistent
        max-width="290"
      >
        <v-card>
          <v-card-title class="text-h5">
            تنبية!
          </v-card-title>
          <v-card-text>تاكيد ارسال نتيجة المحتسب للعميل؟</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              text
              @click="$store.state.save_result_dialog = false"
            >
              الغاء
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="calaculatorAgreefn()"
            >
              موافق
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </page-component>
</template>

<script>
import Axios from "axios";
import { axiosInstance } from "@/axios/config";
import ReciveIcon from "../Charts/ReciveIcon.vue";
import FundingReciveIcon from "@/views/funding_manager/FundingReciveIcon.vue";
import AdminProcess from "@/components/AdminComponent/AdminProcess.vue";
import AgentSendPaymentDialog from "@/components/Dialogs/AgentSendPaymentDialog.vue";
import ValidationAsDialog from "@/components/Dialogs/ValidationAsDialog.vue";
import DosentWantOurProductDialog from "@/components/Dialogs/DosentWantOurProductDialog.vue";
import FMRejectRequestDialog from "@/components/Dialogs/FundingManager/FMRejectRequestDialog.vue";
import FMSendRequestDialog from "@/components/Dialogs/FundingManager/FMSendRequestDialog.vue";
import FMApproveRequestDialog from "@/components/Dialogs/FundingManager/FMApproveRequestDialog.vue";
import FMCancelPaymentDialog from "@/components/Dialogs/FundingManager/FMCancelPaymentDialog.vue";
import FMSendPaymentDialog from "@/components/Dialogs/FundingManager/FMSendPaymentDialog.vue";
import FMSendRequestToBankDialog from "@/components/Dialogs/FundingManager/FMSendRequestToBankDialog.vue";
import FMCreatePaymentDialog from "@/components/Dialogs/FundingManager/FMCreatePaymentDialog.vue";
import RequestStationsByUser from "./RequestStationsByUser.vue";
import AgentRejectRequestDialog from "@/components/Dialogs/AgentRejectRequestDialog.vue";
import AgentClassificationLabelComponent from "@/components/Requests/AgentClassificationLabelComponent.vue";
import css from "./DetailsStyle.css";
import requestLifecycleEditMixin from "@/mixins/requestLifecycleEditMixin";
import { customerSituationFixMixin } from "@/mixins/customerSituationFixMixin";
import postponedCommunicationMixin from "@/mixins/postponedCommunicationMixin";
import { resolveProductTypeSelectState, applyForcedProductTypeClearing } from "@/helper/productTypeSelectHelper";

export default {
  name: "RequestDetails",
  mixins: [requestLifecycleEditMixin, customerSituationFixMixin, postponedCommunicationMixin],
  data: () => ({
    callTimeError: null,
    reqTypes: ['شراء', 'رهن', 'رهن-شراء','رهن-مباشر'],
    selected_products_list: [],
    TempNote: "",
    loading: false,
    openInformationRequest: false,
    active: false,
    tab: "",
    CurrentRole: 0,
    arrayOfErrors : [],
    showStationsDialog: false,
    showRejectDialog: false,

    array:
        [
          'request_id',
          'rejection_id_agent',
          'rejection_id_cs',
          'jointobligations_value',
          'possible_to_sell_to_customer',
          'possible_to_sell_to_customer_no',
          'funding_source',
          'fundDur',
          'fundPersPre',
          'fundReal',
          'fundRealPre',
          'fundMonth',
          'realType',
          'realCity',
          'bank_notes',
          'reqtyp',
          'req_product_type',
          'has_property',
          'owning_property',
          'comment',
          'customer_needs_id',
          'quacomment',
          'class_id_agent',
          'class_id_cs',
          'objections_challenges_id',
          'obstacles_id',
          'class_agent',
          'agent_notes'
        ],
    selected : [],
    agent: {},
    isAdmin: localStorage.getItem("isAdmin"),
    name: "",
    old_class_id_agent: "",
    getAgentClass: "",
    SelectedProTypes: [
      { id: "commercial_finance", value: "تمويل تجاري" },
      { id: "self_build", value: "بناء ذاتي" },
      { id: "complete_construction", value: "اكمال البناء" },
      { id: "land_loan", value: "أرض و قرض" },
      { id: "mortgage", value: "رهن عقار" },
      { id: "buy_property", value: "شراء عقار" },
      { id: "personal_loan", value: "قرض شخصي" },
    ],
    callTimeItems: [
      {id:'before_noon', value:'قبل الظهر'},
      {id:'after_noon', value:'بعد الظهر'},
      {id:'after_asr', value:'بعد العصر'}
    ],
    todayDateFormat:
      new Date().getFullYear() +
      "-" +
      ("0" + (new Date().getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + new Date().getDate()).slice(-2),
  }),
  computed: {
    //=========================================================================================
    selectedCallTime: {
      get() {
        return this.agent?.customer?.call_time ?? null;
      },
      set(val) {
        if (this.agent?.customer) {
          this.agent.customer.call_time = val;
        }
      },
    },
    //=========================================================================================
    //==========================================================================================================
    productTypeSelectState() {
      return resolveProductTypeSelectState(this.agent, this.selected_products_list);
    },
    productTypeItems() {
      return this.productTypeSelectState.items;
    },
    productTypeModel: {
      get() {
        if (this.productTypeSelectState.forceEmpty && !this.agent.req_product_type) {
          return null;
        }
        return this.agent.req_product_type;
      },
      set(val) {
        this.agent.req_product_type = val;
        if (this.$store.state.request_info) {
          this.$store.state.request_info.req_product_type = val;
        }
      },
    },
    //==========================================================================================================
    // مصدر المعاملة: locked for everyone once a source is set, except the system admin
    // (role 7) — only role 7 is allowed by the API (UpdateTrait::updateRequestInfo) to re-assign it.
    requestSourceDisabled() {
      if (this.isSystemAdminViewer) return false;
      return this.agent.source > 0;
    },
    //==========================================================================================================
    isCustomerServiceUser() {
      return (
        localStorage.getItem("role") === "0" &&
        localStorage.getItem("is_customer_service") === "1"
      );
    },
    isRole0NotCustomerService() {
      return (
        localStorage.getItem("role") === "0" &&
        localStorage.getItem("is_customer_service") !== "1"
      );
    },
    isRole16() {
      return localStorage.getItem("role") === "16";
    },
    showBothRejections() {
      return !this.isCustomerServiceUser && !this.isRole0NotCustomerService;
    },
    showAgentRejection() {
      return this.isRole0NotCustomerService || this.showBothRejections;
    },
    showCsRejection() {
      return this.isCustomerServiceUser || this.showBothRejections;
    },
    detailsBasePath() {
      // If user is CS (or already on CS details route), keep navigation inside CS details path.
      if (
        this.$route &&
        typeof this.$route.path === "string" &&
        this.$route.path.startsWith("/customer-service/requests/")
      ) {
        return "/customer-service/requests";
      }
      return this.isCustomerServiceUser ? "/customer-service/requests" : "/requests";
    },
    activeRouteName() {
      // VueRouter name is undefined for unnamed child routes; we infer the equivalent "legacy" name from the URL segment.
      if (this.$route && this.$route.name) return this.$route.name;
      const path = (this.$route && this.$route.path) || "";
      const last = path.split("/").filter(Boolean).pop();
      const map = {
        "agent-data": "agent_data",
        "real-estate-data": "real_estate_data",
        "fund-data": "fund_data",
        "fund-calculator": "fund_calc",
        attachments: "attachments",
        prepayment: "prepayment",
        logs: "logs",
        tickets: "tickets",
        calls: "calls",
      };
      return map[last] || undefined;
    },
    tabLabels() {
      return {
        agent_data: "بيانات العميل",
        real_estate_data: "بيانات العقار",
        fund_data: "بيانات التمويل",
        fund_calc: "حاسبة التمويل",
        attachments: "مرفقات الطلب",
        prepayment: "الدفعة و التساهيل",
        logs: "سجل الطلب",
        tickets: "تذاكر الطلب",
        calls: "المكالمات",
      };
    },
    for_agent() {
      return (
        this.$store.state.request_info.statusReq == 0 ||
        this.$store.state.request_info.statusReq == 1 ||
        this.$store.state.request_info.statusReq == 2 ||
        this.$store.state.request_info.statusReq == 4 ||
        (localStorage["role"] && localStorage["role"] == "2") && [6, 8, 13, 21, 25].includes(this.$store.state.request_info.statusReq)
      );
    },

    forMorPur() {
      return (
        this.$store.state.request_info.statusReq == 19 &&
        this.$store.state.request_info.type == "رهن-شراء"
      );
    },

    morPurFieldsDisabled() {
      return this.requestFieldsDisabled && !this.forMorPur;
    },

    filteredItems() {
      return this.$store.state.request_class.map((item) => {
        if (this.agent.class_id_agent === 61 && item.id === 61) {
          return {
            ...item,
            disabled: true,
          };
        } else {
          return item;
        }

        // const modifiedItem = { ...item };
        // if (this.agent.class_id_agent === 61 && item.id === 61) {
        //   modifiedItem.disabled = true;
        //   modifiedItem.class = 'special-item';
        // }
        // return modifiedItem;
      });
    },
    // Determine product type
    isCommercialProduct() {
      //product became commercial if it is commercial_finance or تجاري or customer_request_type_id is 11 {طلب تمويل تجارى}
      // console.log("customer_request_type_id", this.agent.customer_request_type_id);
      return this.agent.req_product_type === 'commercial_finance' || this.agent.req_product_type === 'تجاري' || this.agent.customer_request_type_id === 11 ;
    },
    isPersonalProduct() {
      return this.agent.req_product_type === 'personal_loan' || this.agent.req_product_type === 'شخصي';
    },
    isBuyProduct() {
      return (
        this.agent.req_product_type === 'buy_property' ||
        this.agent.req_product_type === 'self_build' ||
        this.agent.req_product_type === 'شراء' ||
        this.agent.req_product_type === 'بناء ذاتي'
      );
    },
    isMortgageProduct() {
      return (
        this.agent.req_product_type === 'mortgage' ||
        this.agent.req_product_type === 'رهن' ||
        this.agent.req_product_type === 'direct_mortgage' ||
        this.agent.req_product_type === 'رهن مباشر'
      );
    },
    situationFixRoleAllowed() {
      return this.isRole0NotCustomerService;
    },
    // Determine which fields to show based on product type
    showRequestDescription() {
      return this.isCommercialProduct || this.isPersonalProduct || this.isBuyProduct || this.isMortgageProduct;
    },
    firstClassificationDisplay() {
      const data = this.agent.first_classification_on_request;
      if (!data) {
        return '-';
      }
      const classification = data.classification || '';
      const by = data.by ? ` (${data.by})` : '';
      return `${classification}${by}` || '-';
    },
    campaignSourceDisplay() {
      const customer = this.agent.customer;
      if (!customer || !customer.hamla_source) {
        return '-';
      }
      return customer.hamla_source;
    },
  },
  methods: {
    applyProductTypeSelectRules() {
      applyForcedProductTypeClearing(this.agent, this.$store);
    },
    detailsTabTo(routeName) {
      const routeNameToChildPath = {
        agent_data: "agent-data",
        real_estate_data: "real-estate-data",
        fund_data: "fund-data",
        fund_calc: "fund-calculator",
        attachments: "attachments",
        prepayment: "prepayment",
        logs: "logs",
        tickets: "tickets",
        calls: "calls",
      };
      const childPath = routeNameToChildPath[routeName] || routeName;
      const id = this.$route && this.$route.params ? this.$route.params.id : undefined;
      if (!id) return this.detailsBasePath;
      return `${this.detailsBasePath}/${id}/${childPath}`;
    },
    calaculatorAgreefn(){
      this.$store.state.calaculatorAgree = true;
      this.$store.state.save_result_dialog = false;
    },
    toggleNavClass() {
      if (this.active == false) {
        return "nav";
      } else {
        return "sticky-nav";
      }
    },
    checkClickNumberReqType() {
      if (this.$store.state.fieldCount % 2 === 0) {
        this.show_Field_log("reqtyp1");
      } else {
        this.show_Field_log("reqtyp");
      }
      this.$store.state.fieldCount++;
    },
    checkClickNumberSource() {
      if (this.$store.state.fieldCount % 2 === 0) {
        this.show_Field_log("collaborator_name1");
      } else {
        this.show_Field_log("collaborator_name");
      }
      this.$store.state.fieldCount++;
    },
    checkClickNumberClassAgent() {
      if (this.$store.state.fieldCount % 2 === 0) {
        this.show_Field_log("class_agent1");
      } else {
        this.show_Field_log("class_agent");
      }
      this.$store.state.fieldCount++;
    },
    checkClickNumberRejectionAgent() {
      if (this.$store.state.fieldCount % 2 === 0) {
        this.show_Field_log("rejection_id_agent1");
      } else {
        this.show_Field_log("rejection_id_agent");
      }
      this.$store.state.fieldCount++;
    },
    checkClickNumberComment() {
      if (this.$store.state.fieldCount % 2 === 0) {
        this.show_Field_log("comment1");
      } else {
        this.show_Field_log("comment");
      }
      this.$store.state.fieldCount++;
    },
    disableLifted() {
      setTimeout(() => {
        document
          .querySelectorAll(
            ".v-menu__content.menuable__content__active .v-list-item__title"
          )
          .forEach((el) => {
            if (el.innerHTML == "مرفوع") {
              el.parentElement.parentElement.style.pointerEvents = "none";
              el.style.color = "#979797";
            }
          });
      }, 500);
    },

    resetErrors(){
      this.array.forEach((status, index) => {
        let element = document.getElementById(status);
        if (element) {
          //   element.style.border = "2px solid #f00"; // Apply red border
          element.style.color = "rgba(0, 0, 0, 0.87)"; // Apply red border
        }
      });
      this.$store.state.arrayOfErrors = [];

    },
    get_request_details() {
      this.resetErrors()
      this.loading = true;
      Axios.get(
        `${this.$store.state.url}/v2/employee/Requests/${this.$route.params.id}`,
        {
          headers: this.request_headers(),
        }
      )
        .then((response) => {
          if (response.data.payload.funding !== undefined && response.data.payload.funding.realFun_cost !== undefined  && response.data.payload.funding.realFun_cost != null && response.data.payload.funding.realFun_cost > 0 ) {
              this.$store.state.calaculatorSaved = true;
          }
          if (response.data.payload.type == "not_response_class") {
            if (response.data.payload && response.data.payload.request_id) {
              this.showPopupWithBtn(
                "error",
                response.data.message,
                "فتح الطلب",
                response.data.payload.request_id
              );
              this.loading = false;
              //this.$router.go(-1);
            }

            if (response.data.payload && response.data.payload.ticket_id) {
              console.log('open ticket');
              this.showPopupWithBtn(
                "error",
                response.data.message,
                "فتح التذكرة",
                response.data.payload.ticket_id
              );
              this.loading = false;
            }

          } else {
            this.agent = response.data.payload;
            if (this.CurrentRole == 0 
            && this.agent.class_id_agent != 58 
            && this.agent.class_id_agent != 57) {
              //this.agent.class_id_agent = null;
              //this.agent.agent_notes = null;
              //this.agent.possible_to_sell_to_customer = null;
            }
            this.old_class_id_agent = response.data.payload.class_id_agent;
            /* this code commented by Khaled
            // if (this.agent.prepayments == null) {
            //   this.agent.prepayments = {};
            // }
            */

            // this.$store.state.request_info = response.data.payload;
            this.$store.state.request_info = this.agent;
            applyForcedProductTypeClearing(this.agent, this.$store);
            this.loading = false;
            this.setBreadCrumbs(["الرئيسية", "الطلبات", this.agent.customer.name]);
            this.$store.state.request_class.forEach((el) => {
              if (el.id == this.agent.class_id_agent) {
                this.getAgentClass = el.value;
              }
            });
            this.agent.follow_time = response.data.payload.date_time_agent
              ? response.data.payload.date_time_agent.reminder_date.split(" ")[1]
              : "";
            this.agent.follow_date = response.data.payload.date_time_agent
              ? response.data.payload.date_time_agent.reminder_date.split(" ")[0]
              : "";
            this.$root.$emit("request-details-refreshed", this.agent);
            if (this.isRejectedClass(this.agent.class_id_agent) || this.isRejectedClass(this.agent.class_id_cs)) {
              this.get_rejection_list();
            }
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log('enter in error block !');
            this.showPopup("error", err.response.data.message);
            this.loading = false;
            this.$router.go(-1);
          } else {
            console.log(err);
          }
        });
    },
    to_request_details(item) {
      this.$router.push({ path: `${this.detailsBasePath}/${item.id}` });
    },
    isKeyExists(item) {
      if (Array.isArray(this.$store.state.arrayOfErrors)){
        return this.$store.state.arrayOfErrors.includes(item);
      }
      return false;
    },
    to_tickets_page(item) {
      this.$router.push({ path: `${this.detailsBasePath}/${item.id}/tickets` });
    },

    async getRequestSettings() {
      await Axios.get(`${this.$store.state.url}/employee/request-source-settings`, {
        headers: this.request_headers(),
      }).then((response) => {
        this.selected = response.data.payload.selected.map(value => parseInt(value));
      });
    },

    async get_rejection_list(productType) {
      const resolvedType = productType !== undefined ? productType : this.agent.req_product_type;
      if (!resolvedType) {
        this.$store.state.rejection_list = [];
        return;
      }

      if (!this._rejectionListRequestId) {
        this._rejectionListRequestId = 0;
      }
      const requestId = ++this._rejectionListRequestId;
      const url = `${this.$store.state.url}/agent/Rejections/Reasons?productType=${resolvedType}`;

      await Axios.get(url, {
        headers: this.request_headers(),
      }).then((response) => {
        if (requestId !== this._rejectionListRequestId) {
          return;
        }
        if (this.agent.req_product_type !== resolvedType) {
          return;
        }
        this.$store.state.rejection_list = response.data.payload || [];
      });
    },

    handleRequestRejected(data) {
      // Handle successful rejection
      this.showRejectDialog = false;
      // Refresh request details
      this.get_request_details();
      // Show success notification (already shown in dialog)
    },
    sendRequstToAdmin(values) {
      const formData = new FormData();
      // if(this.agent.agent_notes == null || this.agent.agent_notes == undefined || this.agent.agent_notes == ''){
      //   this.showPopup("error", "الملاحظة مطلوبة");
      //   return;
      // }
      // formData.append("comment", this.agent.agent_notes);

      const hasComment = this.agent.agent_notes && this.agent.agent_notes.trim() !== '';
      const hasCustomerServiceNote = this.agent.customer_service_note && this.agent.customer_service_note.trim() !== '';
      
      if (!hasComment && !hasCustomerServiceNote) {
        this.showPopup("error", "يجب إدخال الملاحظة أو ملاحظة خدمة العملاء");
        return;
      }
      
      if (hasComment) {
        formData.append("comment", this.agent.agent_notes);
      }
      
      if (hasCustomerServiceNote) {
        formData.append("customer_service_note", this.agent.customer_service_note);
      }

      axiosInstance
        .post(`/v2/employee/Requests/moveToAdministration/${values}`, formData, {
          headers: this.request_headers(),
        })
        .then((res) => {
          this.showPopup("success",res.data.message)
          setTimeout(() => {
            this.$router.push({ name: "AllRequests" });
            window.location.reload();
          }, 1000);
         
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message.comment);
        });
    },

  },


  created() {
    this.get_request_details();
    this.$store.state.calaculatorAgree = false;
    this.$store.state.calaculatorSaved = true;
  },

  watch: {
    "$store.state.selected_products": function (val) {
      if (val) {
        // Apply filter based on current request type
        if (this.agent.type == 'شراء') {
          const allowedProductsForBuyIds = ['self_build', 'land_loan', 'buy_property', 'commercial_finance', 'personal_loan'];
          this.selected_products_list = this.$store.state.selected_products.filter((item) => {
            const v = String(item.value || "").replace(/\s+/g, "");
            return (
              allowedProductsForBuyIds.includes(item.id) ||
              v.includes("بناءذاتي") ||
              v.includes("أرضوقرض") ||
              v.includes("ارضوقرض") ||
              v.includes("شراءعقار") ||
              v.includes("تجاري") ||
              v.includes("شخصي")
            );
          });

          // If current selected product isn't in the allowed list, clear it
          if (
            this.agent.req_product_type &&
            !this.selected_products_list.some((p) => p.id === this.agent.req_product_type)
          ) {
            this.agent.req_product_type = "";
          }
        } else if (this.agent.type == 'رهن') {
          const allowedProductsForMortgageIds = ['complete_construction', 'mortgage'];
          this.selected_products_list = this.$store.state.selected_products.filter((item) => {
            const v = String(item.value || "").replace(/\s+/g, "");
            return (
              allowedProductsForMortgageIds.includes(item.id) ||
              v.includes("اكمالالبناء") ||
              v.includes("إكمالالبناء") ||
              v.includes("رهنعقار")
            );
          });

          // Default to "رهن عقار" if not set / not allowed
          const mortgageItem =
            this.selected_products_list.find((p) => String(p.value || "").includes("رهن")) ||
            this.selected_products_list.find((p) => p.id === "mortgage");
          if (
            mortgageItem &&
            (!this.agent.req_product_type ||
              !this.selected_products_list.some((p) => p.id === this.agent.req_product_type))
          ) {
            this.agent.req_product_type = mortgageItem.id;
          }
        } else if (this.agent.type == 'رهن-مباشر') {
          // Direct mortgage is its own product. Do not send the mortgage id,
          // because the API stores mortgage as رهن عقار and rewrites the type to رهن.
          this.selected_products_list = [{ id: 'direct_mortgage', value: 'رهن مباشر' }];
          if (this.agent.req_product_type !== 'direct_mortgage') {
            this.agent.req_product_type = 'direct_mortgage';
          }
        } else if (this.selected_products_list.length == 0) {
          this.selected_products_list = this.$store.state.selected_products;
        }
      }
    },
    "agent.type": function (val) {
      if (val && this.$store.state.selected_products && this.$store.state.selected_products.length > 0) {
        if (val == 'شراء') {
          if (this.agent.req_product_type == 'mortgage' || this.agent.req_product_type == 'complete_construction') {
            this.agent.req_product_type = '';
          }
          // Filter to show only: بناء ذاتي، ارض وقرض، شراء عقار، تجاري ، شخصي
          // Exclude: mortgage, complete_construction
          const allowedProductsForBuyIds = ['self_build', 'land_loan', 'buy_property', 'commercial_finance', 'personal_loan'];
          this.selected_products_list = this.$store.state.selected_products.filter((item) => {
            const v = String(item.value || "").replace(/\s+/g, "");
            return (
              allowedProductsForBuyIds.includes(item.id) ||
              v.includes("بناءذاتي") ||
              v.includes("أرضوقرض") ||
              v.includes("ارضوقرض") ||
              v.includes("شراءعقار") ||
              v.includes("تجاري") ||
              v.includes("شخصي")
            );
          });

          if (
            this.agent.req_product_type &&
            !this.selected_products_list.some((p) => p.id === this.agent.req_product_type)
          ) {
            this.agent.req_product_type = "";
          }
        }else if (val == 'رهن') {
          // Filter to show only: إكمال البناء، رهن عقار
          const allowedProductsForMortgageIds = ['complete_construction', 'mortgage'];
          this.selected_products_list = this.$store.state.selected_products.filter((item) => {
            const v = String(item.value || "").replace(/\s+/g, "");
            return (
              allowedProductsForMortgageIds.includes(item.id) ||
              v.includes("اكمالالبناء") ||
              v.includes("إكمالالبناء") ||
              v.includes("رهنعقار")
            );
          });

          const mortgageItem =
            this.selected_products_list.find((p) => String(p.value || "").includes("رهن")) ||
            this.selected_products_list.find((p) => p.id === "mortgage");
          if (
            mortgageItem &&
            (!this.agent.req_product_type ||
              !this.selected_products_list.some((p) => p.id === this.agent.req_product_type))
          ) {
            this.agent.req_product_type = mortgageItem.id;
          }
        } else if (val == 'رهن-مباشر') {
          // Direct mortgage is its own product, not mortgage / رهن عقار.
          this.selected_products_list = [{ id: 'direct_mortgage', value: 'رهن مباشر' }];
          if (this.agent.req_product_type !== 'direct_mortgage') {
            this.agent.req_product_type = 'direct_mortgage';
          }
        } else {
          this.selected_products_list = this.$store.state.selected_products;
        }
      }
    },

    "agent.real_estate.has_property": function (newData, old) {
      if (old !== newData) {
        if (this.agent.real_estate.has_property == 0) {
          // this.agent.class_id_agent = 15;
        } else {
          // this.agent.class_id_agent = null;
        }
      }
    },

    "agent.class_id_agent": function (newData, oldVal) {
      if (oldVal !== newData) {
        if (oldVal == 15 && this.agent.real_estate.has_property == 0) {
          this.agent.real_estate.has_property = null;
        }
      }
    },

    "agent.req_product_type": function (newVal, oldVal) {
      if (oldVal !== newVal) {
        this.agent.rejection_id_agent = null;
        this.agent.rejection_id_cs = null;
        this.get_rejection_list(newVal);
      }
    },

    "$store.state.ValidationAsDialogMessage": {
      handler() {
        console.log("possible sell null 1")
        this.agent.possible_to_sell_to_customer = null;
      },
    },
  },

  mounted() {
    this.array.forEach((status, index) => {
      let element = document.getElementById(status);
      if (element) {
        //   element.style.border = "2px solid #f00"; // Apply red border
        element.style.color = "rgba(0, 0, 0, 0.87)"; // Apply red border
      }
    });

    this.getRequestSettings();
    this.CurrentRole = window.localStorage.getItem("role");
    if (this.CurrentRole == 7 || this.CurrentRole == 2) {
      // this.reqTypes = ['شراء', 'رهن', 'شراء-دفعة', 'رهن-شراء','رهن-مباشر'];
    }
    this.$store.state.openDialogMargeUsers = false;
    this.$store.state.arrayOfErrors = [];
    this.$root.$on("RD", () => {
      this.get_request_details();
    });
    window.document.onscroll = () => {
      let navBar = document.getElementById("nav");
      this.active = window.scrollY > navBar?.offsetTop;
    };
    // Apply filter based on current request type if exists
    if (this.agent.type == 'شراء') {
      const allowedProductsForBuyIds = ['self_build', 'land_loan', 'buy_property', 'commercial_finance', 'personal_loan'];
      this.selected_products_list = this.$store.state.selected_products.filter((item) => {
        const v = String(item.value || "").replace(/\s+/g, "");
        return (
          allowedProductsForBuyIds.includes(item.id) ||
          v.includes("بناءذاتي") ||
          v.includes("أرضوقرض") ||
          v.includes("ارضوقرض") ||
          v.includes("شراءعقار") ||
          v.includes("تجاري") ||
          v.includes("شخصي")
        );
      });
    } else if (this.agent.type == 'رهن') {
      const allowedProductsForMortgageIds = ['complete_construction', 'mortgage'];
      this.selected_products_list = this.$store.state.selected_products.filter((item) => {
        const v = String(item.value || "").replace(/\s+/g, "");
        return (
          allowedProductsForMortgageIds.includes(item.id) ||
          v.includes("اكمالالبناء") ||
          v.includes("إكمالالبناء") ||
          v.includes("رهنعقار")
        );
      });
    } else if (this.agent.type == 'رهن-مباشر') {
      // Direct mortgage is its own product, not mortgage / رهن عقار.
      this.selected_products_list = [{ id: 'direct_mortgage', value: 'رهن مباشر' }];
      if (this.agent.req_product_type !== 'direct_mortgage') {
        this.agent.req_product_type = 'direct_mortgage';
      }
    } else {
      this.selected_products_list = this.$store.state.selected_products;
    }
  },
  components: { AdminProcess, ReciveIcon, FundingReciveIcon, AgentSendPaymentDialog, ValidationAsDialog, DosentWantOurProductDialog,FMRejectRequestDialog,FMSendRequestDialog,FMApproveRequestDialog,FMCancelPaymentDialog,FMSendPaymentDialog,FMSendRequestToBankDialog,FMCreatePaymentDialog, RequestStationsByUser, AgentRejectRequestDialog, AgentClassificationLabelComponent },
};
</script>

<style lang="scss">

.footer__container .theme--light.v-input input, .theme--light.v-input textarea{
  color: black !important;
}
.v-slide-group__content .v-tabs-bar__content .a {
  text-decoration: none !important;
  color: white !important;
}

.follow-req-time {
  input {
    text-align: end !important;
  }
}

.nav {
  transition: 10ms;
  padding: 25px;
}

.sticky-nav {
  transition: 100ms;
  padding: 20px;
}

#nav {
  margin-top: 25px;
  margin-bottom: 25px;
}

#nav.sticky {
  position: fixed;
  z-index: 2;
  top: 0;
  width: 97%;
  right: 56px;
  margin-bottom: 25px;
  margin-top: 0px;
  padding-top: 20px;
  padding-left: 25px;
  padding-bottom: 10px;
}

.special-item {
  background-color: red !important;
  color: green !important;
}

.footer__container .v-select.v-text-field:not(.v-text-field--single-line) input {
  color: white;
}

// .footer__container
//   .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
//   > .v-input__control
//   > .v-input__slot
//   fieldset {
//   border: 1px solid #451646 !important;
// }

.footer__container .theme--light.v-input input,
.theme--light.v-input textarea {
  color: white;
}

.v-application--is-rtl .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
  color: black;
}
</style>
